import React from "react";
import PropTypes from 'prop-types';
import collapse from './collapse.svg'
import styles from './layer-element.module.css'
import LayerElement, { layerType } from './layer-element'

export default function TerrainControl({
    terrain,
    setTerrain,
    setTerrainProvider,
    callbackFunction
}) {
    const changeTerrain = (t) => {
        let newTerrain = { ...terrain };
        newTerrain.elements = [...terrain.elements];
        newTerrain.elements[newTerrain.elements.indexOf((e) => e.id === t.id)] = t;
        setTerrain(newTerrain);
    };
    const changeTerrainVisible = (t) => {
        if (!t.visible) { //обработка только включения слоя
            callbackFunction.current = () => setTerrainProvider(t);
            let newTerrain = { ...terrain };
            newTerrain.elements = terrain.elements.map(e => { return { ...e, visible: e.id === t.id ? true : false }; });
            setTerrain(newTerrain);
        }
    }

    return (
        <div className={styles.layerElementContainer}>
            <div className={styles.layerElement}>
                <img
                    className={terrain.collapsed === true ? styles.groupElementImgCollapsed : styles.groupElementImg}
                    src={collapse}
                    onClick={() => setTerrain({ ...terrain, collapsed: !terrain.collapsed })}
                ></img>
                <div className={styles.labelContainer}>
                    <div className={styles.label}>{terrain.label}</div>
                </div>
            </div>

            <div className={`${styles.elementsContainer} ${terrain.collapsed ? styles.collapsed : ''}`}>
                {terrain.elements.map((l) => (
                    <LayerElement
                        key={l.id}
                        layer={l}
                        parents={[]}
                        changeLayerVisible={changeTerrainVisible}
                        changeLayer={changeTerrain}
                        updateLayerOpacity={() => { }}
                        callbackFunction={callbackFunction}
                    />
                ))}
            </div>
        </div>
    )
}

TerrainControl.propTypes = {
    terrain: layerType.isRequired,
    setTerrainProvider: PropTypes.func.isRequired,
    setTerrain: PropTypes.func.isRequired,
    callbackFunction: PropTypes.object.isRequired,
};